import styled from 'styled-components';

const MyDiv = styled.div`

/* =========================
   MAIN LAYOUT
========================= */

.parent_grid {
  display: grid;
  grid-template-columns: 237px 1fr;
  min-height: 100vh;
  background: #FFFFFF;
  transition: 0.4s ease;

  @media(max-width:767px) {
    display: block;
  }
}

.parent_grid_toggle {
  display: grid;
  grid-template-columns: 90px 1fr;
  min-height: 100vh;
  background: #FFFFFF;
  transition: 0.4s ease;
}

/* =========================
   RIGHT SIDE CONTENT
========================= */

// .children_grid,
// .children_grid_toggle {

//   min-height: 100vh;
//   background: #FFFFFF;
//   display: flex;
//   flex-direction: column;
// }

// .inner-children {

//    flex: 1;
//   min-height: calc(100vh - 70px);
//   background: #F5F5FA;
//   padding: 24px;
// }

/* =========================
   REMOVE EXTRA SPACING
========================= */

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.parent_grid,
.parent_grid_toggle {
  height: 100vh;
  overflow: hidden;
}

.children_grid,
.children_grid_toggle {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.inner-children {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #F5F5FA;
  padding: 24px;
}

`;

export default MyDiv;